if (!customElements.get('featured-collection-tabs')) {
  class FeaturedCollectionTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('.js-tab-item');
      this.contents = this.querySelectorAll('.js-content');
    }

    connectedCallback() {
      this.addTabsListeners();
    }

    addTabsListeners() {
      const tabsListEl = this.querySelector('.js-tabs-list');
      if (!tabsListEl) return;

      tabsListEl.addEventListener('click', this.onTabChange.bind(this));
    }

    onTabChange(event) {
      const clickedTabEl = event.target.closest('.js-tab-btn');
      const tabId = clickedTabEl?.parentElement?.dataset.id;
      if (!clickedTabEl) return;

      this.resetActiveState();
      this.setActiveTab(tabId);
    }

    setActiveTab(tabId) {
      const activeTabEl = this.querySelector(`.js-tab-item[data-id="${tabId}"]`);
      const activeContentEl = this.querySelector(`.js-content[data-id="${tabId}"]`);

      if (activeTabEl) activeTabEl.classList.add('featured-collection-tabs__tabs-item--active');
      if (activeContentEl) activeContentEl.classList.add('featured-collection-tabs__content-item--active');
    }

    resetActiveState() {
      this.tabs.forEach(tabEl => {
        tabEl.classList.remove('featured-collection-tabs__tabs-item--active');
      });

      this.contents.forEach(contentEl => {
        contentEl.classList.remove('featured-collection-tabs__content-item--active');
      });
    }
  }

  customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
}
